import { OverlayTrigger, Tooltip } from "solid-bootstrap";
import { Component, createSignal, For, JSX, onMount, Show } from "solid-js";
import { NotificationRender } from "./notification-render";
import { fetchGet } from "../library/common";

export type Notification = {
    id: number;
    text: string;
    imageUrl: string;
    url: string;
    dateAddedUTC: Date;
    isViewed: boolean;
    notificationTypeCode: string;
};

const TooltipLink = (props: { id: string; children: JSX.Element; title: string }) => (
    <OverlayTrigger overlay={<Tooltip id={props.id}>{props.title}</Tooltip>}><a>{props.children}</a></OverlayTrigger>
);

export const Notifications : Component = () => {
    const [notifications, setNotifications] = createSignal<any[]>([]);
    const [count, setCount] = createSignal<number>(0);
    const [page, setPage] = createSignal<number>(1);
    const [maxPage, setMaxPage] = createSignal<number>(1);
    const getNotifications = async () => {
        const response = await fetch("/Notifications/ListJson");
        const json = await response.json();
        return json;
    };
    const getModel = () => ({
        page: page(),
        pageRows: 10,
        orderBy: "ByDateAdded",
        direction: "Descending"
    });
    const skipToLastPageClicked = async (e: Event) => {
        e.preventDefault();
        setPage(maxPage());
        await loadNotifications();
    };
    const skipToFirstPageClicked = async (e: Event) => {
        e.preventDefault();
        setPage(1);
        await loadNotifications();
    };
    const loadPreviousPageClicked = async (e: Event) =>{
        e.preventDefault();
        if (page() == 1){
            return;
        }
        setPage(page()-1);
        await loadNotifications();
    }
    const loadNextPageClicked = async (e: Event) =>{
        e.preventDefault();
        if (page() > maxPage()){
            return;
        }
        setPage(page()+1);
        await loadNotifications();
    };
    const settingsClicked = (e: Event) => {
        e.preventDefault();
        // 
    };
    const toDate = (value: string) => {
        return new Date(value);
    };
    const loadNotifications = async () => {
        const response = await getNotifications();
        if (!response.Success) return;
        const data = response.Data;
        setCount(data.Count);
        setPage(data.Page);
        setMaxPage(data.MaxPage);
        const results = data.Results.map((x: any) => ({
            id: x.Id, text: x.Text, url: x.URL, imageUrl: x.ImageURL, dateAddedUTC: toDate(x.dateAddedUTC),
            isViewed: x.IsViewed, notificationTypeCode: x.NotificationTypeCode
        } as Notification)) as Notification[];
        setNotifications(results);
    };
    const signUpForNotificationsClicked = (e: Event) => {
        e.preventDefault();
        // TBC
    };
    const reload = async () => {
        setPage(1);
        setMaxPage(1);
        await loadNotifications();
    };
    const markReadAllClicked = async (e: Event) =>{
        e.preventDefault();
        const response = await fetch("/Notification/MarkReadAll");
        const json = await response.json();
        if (!json.Success) return;
        await reload();
    };
    const hideAllClicked = async (e: Event) =>{
        e.preventDefault();
        const response = await fetch("/Notification/HideAll");
        const json = await response.json();
        if (!json.Success) return;
        await reload();
    };
    const seeAllClicked = (e: Event) =>{
        e.preventDefault();
        window.location.href = "/Notification/ShowAll";
    };
    const hide = async (notification: any) => {
        const response = await fetchGet("/Home/HideNotificationJson", { id: notification.id });
        await loadNotifications();
    };
    onMount(async () => {
        await loadNotifications();
    });
    return (
        <div>
            <div style="position: relative;">
                <a style={{ "position": "relative", "right": count() > 0 ? "-5px" : "10px", "top": "12px" }}>
                    <span class="fa" data-bind="style: { color: $data.computed.activeColor }, css: { 'fa-bell': $data.hasAwaitingNotifications, 'fa-bell-o': false == $data.hasAwaitingNotifications(), 'animated swing': $data.hasAwaitingNotifications }"></span>
                </a>
                <Show when={count()}>
                    <span style="background-color: red; color: white; padding: 5px; border-radius: 50%; position: relative; top: 5px; right: 7px;">{count()}</span>    
                </Show>
            </div>
            <div class="megamenu" style="background-color: rgb(216, 216, 216); padding:0; margin: 0; color: #000;">
                <div class="notifications">
                    <div class="notifications__nav">
                        <div style="display: inline-block;">
                            <div>
                                <button class="btn btn-default" onClick={skipToFirstPageClicked} disabled={page() == 1}><span class="fa fa-fast-backward"></span></button>
                                <button class="btn btn-default" onClick={loadPreviousPageClicked} disabled={page() == 1}><span class="fa fa-chevron-left"></span></button>
                                <button class="btn btn-default" onClick={loadNextPageClicked} disabled={page() == maxPage()}><span class="fa fa-chevron-right"></span></button>
                                <button class="btn btn-default" onClick={skipToLastPageClicked} disabled={page() == maxPage()}><span class="fa fa-fast-forward"></span></button>
                                <button class="btn btn-primary" onClick={seeAllClicked}>See All</button>
                            </div>
                        </div>
                        <div style="display: inline-block; float: right;">

                            <button onClick={markReadAllClicked} class="btn btn-default">
                                <TooltipLink title="Mark all notifications read" id="t-mark-all-read">Mark All Read</TooltipLink>
                            </button>
                            <button onClick={hideAllClicked} class="btn btn-default">
                                <TooltipLink title="Hide all notifications" id="t-hide-all">Hide All</TooltipLink>
                            </button>
                            <button onClick={settingsClicked} class="btn btn-default">
                                <TooltipLink title="Change your notification settings" id="t-settings"><span class="fa fa-cog"></span></TooltipLink>
                            </button>
                        </div>
                    </div>
                    <Show when={count() == 0}>
                        <div class="notifications__no-notifications">
                            <div class="notifications__no-notifications__header">
                                <h3>
                                    You have no notifications at this time ...
                                </h3>
                            </div>
                            <div class="notifications__no-notifications__sign-up" onClick={signUpForNotificationsClicked}>
                                Sign up for notifications ...
                            </div>
                        </div>
                    </Show>
                    <Show when={count()}>
                        <div class="notifications__results">
                            <For each={notifications()}>{(notification) =>
                                <NotificationRender data={notification} />
                            }</For>
                        </div>
                    </Show>
                </div>
            </div>
        </div>
    );
}